import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from 'react-i18next';
import GenericDropdown from "components/dropdowns/GenericDropdown";

const UserDropdown = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { logout, user } = useAuth0();
    const defaultPicture = require("./../../assets/img/anime3.png");
    const [userPicture, setUserPicture] = useState(user?.picture || defaultPicture);

    useEffect(() => {
        setUserPicture(user?.picture || defaultPicture);
    }, [user?.picture]);

    const menuItems = useMemo(() => [
        { label: t('menu.profile'), action: () => { navigate('/admin/profile'); } },
        { label: t('menu.settings'), action: () => { navigate('/admin/settings'); } },
        { label: t('menu.switchApp'), action: () => { navigate('/select-tenant'); } },
        { label: t('menu.settingsWizard'), action: () => { navigate('/settings-wizard'); } },
        { label: t('menu.logout'), action: () => { logout({ logoutParams: { returnTo: window.location.origin } }); }, isDivider: true }
    ], [t, navigate, logout]);

    return (
        <GenericDropdown items={menuItems} onItemSelect={(item) => item.action()}>
            <div className="photo">
                {/*<LazyLoad height={30} placeholder={placeholder}>*/}
                    <img alt={t('menu.languagePictureAlt')} src={userPicture} />
                {/*</LazyLoad>*/}
            </div>
        </GenericDropdown>
    );
};

export default UserDropdown;
